import { LockKeyhole } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function FeatureBlockedPage({
  title = 'Feature disabled',
  message = 'This module is disabled for the current school.',
}) {
  const navigate = useNavigate()

  return (
    <div className="empty-state card">
      <LockKeyhole className="w-10 h-10 text-gray-200" />
      <p className="empty-state-title">{title}</p>
      <p className="empty-state-copy">{message}</p>
      <button onClick={() => navigate('/dashboard')} className="btn-primary mt-4">
        Back to Dashboard
      </button>
    </div>
  )
}
